import { endpoints, QuickBuyProCSSLink, QuickBuyProJSLink } from "endpoints.config";
import { useEffect, useState } from "react";
import api, { ApiResponse, isAxiosErrorHandled } from 'api';
import { RouteComponentProps } from "@reach/router";
import { FoldingCube, RotatingPlane, Wave } from "better-react-spinkit";


export const QuickBuyPro: React.FC<RouteComponentProps> = () => {
  const [loading, setLoading] = useState(true);
  const [widgetData, setWidgetData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const paymentid = new URLSearchParams(window.location.search).get("paymentid");
  const themeId = new URLSearchParams(window.location.search).get("_t");

  useEffect(() => {


    const loadWidget = async () => {
      try {
        if (!paymentid) {
          setError("Token is missing");
          setLoading(false);
          return;
        }
        const response = await api.get(
          `${endpoints.quickBuyPro.getPaymentDetail}?token=${paymentid}&_t${themeId}`
        );
        
        if(response?.data?.details){
           setWidgetData(response?.data?.details);
        }else{
            setError("Invalid or Expired link.");
        }
       

        const script = document.createElement("script");
        script.src = QuickBuyProJSLink;
        script.id = "QuickBuyScript";
        script.async = true;
        document.body.appendChild(script);

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = QuickBuyProCSSLink;
        document.body.appendChild(link);

        const timeoutId = setTimeout(() => {
          const el = document.querySelector(
            "#WidgetContainer .QuickCoinWidget .FormPage.HeightContent"
          ) as HTMLElement;
          if (el) {
            el.style.backgroundImage = "none";
          }
        }, 200); // adjust delay as needed
        return () => {
          if (script && document.body.contains(script)) {
            document.body.removeChild(script);
          }
          if (link && document.body.contains(link)) {
            document.body.removeChild(link);
          }
           clearTimeout(timeoutId);
        };

      } catch (e) {
        setError("Failed to load widget details");
      } finally {
        setLoading(false);
      }
    };

    loadWidget();
  }, [paymentid]);

  // Show loader
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Wave color={"#1943DC"} size={80} />
      </div>
    );

  }
  // Error UI
  if (error) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 'bold'
        }}
      >
        {error}
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div
        id="WidgetContainer"
        data-userreference={widgetData?.clientReference}
        data-clientsignature={widgetData?.paymentID}
        data-quickbuykey={widgetData?.apiKey}
        data-configuration={JSON.stringify({
          userSpecifiedWallet: widgetData?.userSpecifiedWallet ?? false,
          fixedSpendAmount: widgetData?.amount ?? null,
          redirectURL: widgetData?.redirectURL ?? "",
          firstName: widgetData?.clientFirstName ?? "",
          lastName: widgetData?.clientLastName ?? "",
          emailAddress: widgetData?.email ?? "",
          phoneNumber: widgetData?.phoneNumber ?? "",
          hideLogo: true,
          fixedBuyAmountCrypto: widgetData?.cryptoAmount ?? null,
            
        })}
        style={{
          backgroundColor: "#fff",
          maxWidth: "650px",
          width: "100%",
          height: "auto",
          minHeight: "400px",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      ></div>
    </div>
  );
};

